import { useGetLane } from '@api';
import { toast } from '@components';
import { DATE_FORMATS } from '@utils';
import { format } from 'date-fns';
import { useSetRateCardState } from './useRateCardState';

/**
 * Reloads a lane into the rate card state, for when something outside the form
 * has changed the lane on the server (a CPI increase applied immediately, for example)
 * and everything on screen is now stale.
 */
export const useRefetchLane = () => {
	const { isLoadingGetLane, callGetLane } = useGetLane();
	const setRateCard = useSetRateCardState();

	const refetchLane = (externalId: string) => {
		return callGetLane({ routes: [externalId] })
			.then((response) => {
				if (!response?.data) return;
				setRateCard({
					...response.data.data,
					// TODO remove once lanesNoEndDateFeatureFlag flag is removed
					end_date: response.data.data.end_date ? format(new Date(response.data.data.end_date), DATE_FORMATS.SHORT_DATE) : ''
				});
			})
			.catch((err) => {
				console.error(err);
				toast.error('Oops, something went wrong trying to fetch this rate card');
			});
	};

	return {
		isLoadingRefetchLane: isLoadingGetLane,
		refetchLane,
	};
};
